<template>
  <div class="create-rule-wrapper">
    <CreateRuleWrapper :ruleKey="ruleKey"></CreateRuleWrapper>
  </div>
</template>
<script>
import CreateRuleWrapper from '@/components/fantasyconsole/CreateRuleWrapper'

export default {
  components: {
    CreateRuleWrapper
  },
  data () {
    return {
      ruleKey: this.$route.params.key
    }
  },
  mounted () {
  },

  methods: {
  }
}
</script>
